import React, { useEffect, useState } from "react";
import { Button, DropDownField, TextInputField, AutoCompleteField } from "../../../helpers";
import Loading from "../../../common/Loading";

import { ChequeBookValidataionSchema } from "../../../validation/addChequeBook";
import { validateInputs } from "../../../utils";

import { updateChequeBook } from "../../../services/api/chequeBooks";
import { raiseToast } from "../../../services/redux/reducers/toast/toast";
import { useDispatch, useSelector } from "react-redux";
import { editChequeBookAction } from "../../../services/redux/reducers/common";
import { fetchChequeBooks } from "../../../services/redux/reducers/commonThunk";

const EditChequeBook = (props) =>{
    const { chequeBookDetails, setVisibleEditChequeBook } = props

    const [ accountNos, setAccountNos ] = useState("")
    const [ bankNames, setBankNames] = useState([])
    const [formErrors, setFormErrors] = useState({})
    const [isLoading, setIsLoading] = useState(false)
    const [chequeBook, setChequeBook] = useState({...chequeBookDetails})

    const bankDetails = useSelector(state => state.userDetails.PMCompanyDetails.companyBankAccounts)
    const chequeBooks = useSelector(state => state.common.chequeBooks)

    const dispatch = useDispatch()

    useEffect(()=>{
        fetchRealatedAccountNumbers()
        getUniqueBankNames()
    }, [])

    const fetchRealatedAccountNumbers = async () => {
        const realatedAccountNos = bankDetails.filter((each) => {
            if(each.bankName === chequeBook["bankName"]){
                return each
            }
        })
        setAccountNos(realatedAccountNos)
    }

    const getUniqueBankNames = () => {
        const uniqueKeyValues = new Set();

        const uniqueObjects = bankDetails.filter((obj) => {
          const keyValue = obj["bankName"];
          
          if (uniqueKeyValues.has(keyValue)) {
            return false;
          } else {
            uniqueKeyValues.add(keyValue);
            return true;
          }
        });
      
       setBankNames(uniqueObjects)

    }

    const handleInputChange = (event) => {
        chequeBook[event.target.name] = event.target.value
        if(event.target.name === "bankName"){
            fetchRealatedAccountNumbers(chequeBook.bankName)
        }
        if(event.target.name === "accNo"){
            accountNos.find((each) => {
                if(each.accountNumber === event.target.value){
                    chequeBook["ifscCode"] = each.ifscCode
                    chequeBook["bankAccId"] = each.bankAccId
                }
            })
        }
        setChequeBook({...chequeBook})
    }

    const handleUpdateChequeBook= async () => {
        const validationResonse = await validateInputs(ChequeBookValidataionSchema, chequeBook)

        if(validationResonse.error){
            return setFormErrors(validationResonse.error)
        } else {
            setFormErrors({})
            setIsLoading(true)
            const insertChequeBookResponse = await updateChequeBook(chequeBook.chequeBookId, chequeBook)
            setIsLoading(false)
            if(insertChequeBookResponse?.failure){
                return dispatch(raiseToast({severity:'error', summary: 'Cheque Book', detail: insertChequeBookResponse.data.error, life: 3000}))
            }else{
                setVisibleEditChequeBook()
                const updatedChequeBookList = chequeBooks.map((eachChequeBook) => {
                    if(eachChequeBook.chequeBookId === chequeBook.chequeBookId){
                        return {
                            chequeBookId: eachChequeBook.chequeBookId,
                            statudId: 1,
                            ...chequeBook
                        }
                    }else {
                        return eachChequeBook
                    }
                })
                dispatch(editChequeBookAction(updatedChequeBookList))
                dispatch(fetchChequeBooks(false))
                return dispatch(raiseToast({severity:'success', summary: 'Cheque Book', detail: "Updated successfully", life: 3000}))
            }
        }
        
    }

    return(
        <div>
            <Loading visible={isLoading} />
            <div className="grid">
                <div className="flex flex-column col-12 mb-4 lg:col-6 lg:mb-0">
                    <DropDownField name="bankName" labelText="Bank Name" optionLabel="bankName" optionValue="bankName" value={chequeBook?.bankName} options={bankNames} onChange={(event) => handleInputChange(event)} errorMessage={formErrors.bankName}/>
                </div>
                <div className="flex flex-column col-12 mb-4 lg:col-6 lg:mb-0">
                    <DropDownField name="accNo" labelText="Account No" optionLabel="accNo" optionValue="accNo" value={chequeBook?.accNo} options={accountNos} onChange={(event) => handleInputChange(event)} errorMessage={formErrors.accNo}/>
                </div>
                <div className="flex flex-column col-12 mb-2 lg:col-6 lg:mb-0">
                    <TextInputField name="chequeSeriesFrom" labelText="Cheque Series From"  keyfilter="int" value={chequeBook?.chequeSeriesFrom} onChange={(event) => handleInputChange(event)} errorMessage={formErrors.chequeSeriesFrom}/>
                </div>
                <div className="flex flex-column col-12 mb-2 lg:col-6 lg:mb-0">
                    <TextInputField name="chequeSeriesTo" labelText="Cheque Series To" keyfilter="int" value={chequeBook?.chequeSeriesTo} onChange={(event) => handleInputChange(event)} errorMessage={formErrors.chequeSeriesTo}/>
                </div>
                <div className="flex flex-column col-12 mb-2 lg:col-6 lg:mb-0">
                    <AutoCompleteField name="" labelText="IFSC" value={chequeBook?.ifscCode} disabled />
                </div>
                <div className="flex flex-column col-12 mb-2 lg:col-6 lg:mb-0">
                    <TextInputField name="" labelText="A/C Holder's Mobile No." keyfilter="int"/>
                </div>
                <div className="flex flex-column col-12 mb-2 lg:col-12 lg:mb-0">
                    <TextInputField name="" labelText="A/C Holder's Address" />
                </div>
            </div>
            <div className="flex flex-row justify-content-end mt-2">
                <Button label="UPDATE" onClick={() => handleUpdateChequeBook()}/>
            </div>
        </div>
    )
}

export default EditChequeBook;